import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    formContainer: {
        // height: 'calc(100vh - 115px)',
        overflow: 'hidden',
        height: 'calc(100% - 100px)'
    },
    paper: {
        padding: '15px',
        marginBottom: 16,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    name: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#000000',
    },
    actionsContainer: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        zIndex: 2
    },
    actions: {
        display: 'flex',
        gap: '10px',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        flexDirection: 'column',
        position: 'relative',
    },
    draggable: {
        cursor: 'grab'
    },
    columnContainer: {
    },
    leftColumn: {
        'padding': '10px 3px 10px 10px',
        '& .MuiPaper-root': {
            marginBottom: 0
        }
    },
    rightColumn: {
        'backgroundColor': '#999999',
        'padding': '10px',
        'height': '100%',
        '& .MuiPaper-root': {
            marginBottom: '10px'
        }
    },
    fullWidthCard: {
        width: '100%',
    },
    thirdWidthCard: {
        width: '100%', // Grid item with xs=4 handles the width
    },
});
